import { useContext } from 'react'
import { SchedulingWizardContext } from './schedulingWizardContext'

export function useSchedulingWizard() {
  const context = useContext(SchedulingWizardContext)

  if (context === undefined)
    throw Error('Must be descendant of SchedulingContextProvider')

  return context
}
